import { defineComponent, toRef } from 'vue';
import GoogleSigninButton from './GoogleSigninButton/GoogleSigninButton.vue';
import FacebookSigninButton from './FacebookSigninButton/FacebookSigninButton.vue';
import LinkedInSigninButton from './LinkedInSigninButton/LinkedInSigninButton.vue';
import SocialIncentiveButtons from './SocialIncentiveButtons.class';
import { setupComponent } from '@studyportals/vue-platform';
export default defineComponent({
	components: {
		GoogleSigninButton,
		FacebookSigninButton,
		LinkedInSigninButton,
	},
	props: {
		direction: {
			type: String,
			default: 'column'
		},
		template: {
			type: String,
			default: 'Small'
		}
	},
	setup: (props)=>{
		const direction = toRef(props, 'direction');
		const template = toRef(props, 'template');

		const component = new SocialIncentiveButtons(direction, template);
		return setupComponent(component);
	}
});


